import styled from "styled-components";

const VerticalDivider = styled.div<{ $isSmallMobile?: boolean }>`
  width: 1px;
  background-color: ${(p) => p.theme.colors.mediumBorderGrey};
  height: 26px;
  margin: 0 16px;
  @media (max-width: 415px) {
    height: 23px;
  }
  ${(p) =>
    p.$isSmallMobile &&
    `
    margin: 0 12px;
    height: 20px !important;
  `};
`;

export default VerticalDivider;
